'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib = require('tslib');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var Typography = _interopDefault(require('@material-ui/core/Typography'));
var CircularProgress = _interopDefault(require('@material-ui/core/CircularProgress'));
var Card = _interopDefault(require('@material-ui/core/Card'));

var getColorFrom = function (status) {
    switch (status.toLowerCase()) {
        case 'pending':
            return 'lightyellow';
        case 'sent':
            return '#4C7CFD';
        case 'received':
            return '#DEE7EE';
        case 'canceled':
            return 'mistyrose';
        case 'scheduled':
            return 'powderblue';
        default:
            return 'lightgreen';
    }
};
var StyledCard = styled__default(Card)(templateObject_1 || (templateObject_1 = tslib.__makeTemplateObject(["\n  box-shadow: none;\n  background-color: rgba(0, 0, 0, 0);\n"], ["\n  box-shadow: none;\n  background-color: rgba(0, 0, 0, 0);\n"])));
var TitleTypography = styled__default(Typography)(templateObject_2 || (templateObject_2 = tslib.__makeTemplateObject(["\n  display: inline-block;\n  padding: 8px;\n"], ["\n  display: inline-block;\n  padding: 8px;\n"])));
var BodyTypography = styled__default(Typography)(templateObject_3 || (templateObject_3 = tslib.__makeTemplateObject(["\n  background-color: ", ";\n  padding: 10px 20px;\n  border-radius: 0px 10px 10px 10px;\n  color: ", ";\n"], ["\n  background-color: ", ";\n  padding: 10px 20px;\n  border-radius: 0px 10px 10px 10px;\n  color: ", ";\n"])), function (_a) {
    var status = _a.status;
    return getColorFrom(status);
}, function (_a) {
    var status = _a.status;
    return (status === 'sent' ? 'white' : 'black');
});
var LightTextSpan = styled__default.span(templateObject_4 || (templateObject_4 = tslib.__makeTemplateObject(["\n  font-weight: 200;\n  color: #1a252e;\n  opacity: 50%;\n"], ["\n  font-weight: 200;\n  color: #1a252e;\n  opacity: 50%;\n"])));
var StyledCircularProgress = styled__default(CircularProgress)(templateObject_5 || (templateObject_5 = tslib.__makeTemplateObject(["\n  display: inline-block;\n"], ["\n  display: inline-block;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;

exports.BodyTypography = BodyTypography;
exports.LightTextSpan = LightTextSpan;
exports.StyledCard = StyledCard;
exports.StyledCircularProgress = StyledCircularProgress;
exports.TitleTypography = TitleTypography;
